import { Suspense, lazy, useState } from "react";

const FormFlows = lazy(() => import("@Features/forms").then((module) => ({ default: module.FormFlows })));
const FormFlowCreationNew = lazy(() =>
  import("@Features/forms").then((module) => ({ default: module.FormFlowCreationNew })),
);

interface FormflowsWrapperProps {
  projectId: string;
}

function FormflowsWrapper({ projectId }: FormflowsWrapperProps) {
  const [formFlowId, setFormFlowId] = useState<string | null>(null);

  const handleBackClick = () => {
    setFormFlowId(null);
  };

  return (
    <>
      {!formFlowId ? (
        <Suspense>
          <FormFlows setFormFlowId={setFormFlowId} projectId={projectId} />
        </Suspense>
      ) : (
        <Suspense>
          <FormFlowCreationNew
            handleBackClick={handleBackClick}
            formFlowId={formFlowId}
            source="SPACE_SETTINGS"
            projectId={projectId}
          />
        </Suspense>
      )}
    </>
  );
}

export default FormflowsWrapper;
